import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';
import { ErrorResponse } from '~shared/models';

export interface StoryblokSeoState {
  storyblokSEOContent: StoryblokApiResponse;
  loading: boolean;
  error: ErrorResponse;
}

export const StoryblokSeoInitialState: StoryblokSeoState = {
  storyblokSEOContent: null,
  loading: false,
  error: null,
};
